import React from "react";
import Svg, { G, Path } from "react-native-svg";

type Avatar41Colors = {
  background?: string;
  skin?: string;
  accessories?: string;
  hair?: string;
};

export const Avatar41 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar41Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    skin: colors.skin ?? "#fff",
    accessories: colors.accessories ?? "#fff",
    hair: colors.hair ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar41">
        <G id="Group">
          <Path
            id="background"
            d="M151.833 303.667c83.856 0 151.834-67.978 151.834-151.834C303.667 67.978 235.689 0 151.833 0 67.978 0 0 67.978 0 151.833c0 83.856 67.978 151.834 151.833 151.834Z"
            fill={c.background}
          />
          <Path
            id="skin"
            d="M216.979 139.736c0-48.596.159-91.984-41.517-91.984-75.243 0-81.487 30.55-81.487 79.138 0 1.139.032 2.286.088 3.433a12.64 12.64 0 0 0-2.47.589c-6.124 2.063-7.23 13.849-2.476 26.329 4.635 12.169 13.132 20.491 19.233 18.986.382.661.764 1.322 1.155 1.975.43 4.245 2.174 22.578 1.194 30.279-1.115 8.729-7.39 21.192-7.39 21.192s44.311 37.63 75.992 34.827c13.276.04 11.93-12.376 11.93-12.376s-6.714-24.314-.494-25.262c18.867-2.883 15.769-22.801 25.366-57.572 2.086-13.554.876-13.507.876-29.554Z"
            fill={c.skin}
          />
          <Path
            id="Vector"
            d="M129.264 131.294s11.826-2.118 21.869-2.118c7.127 0 16.055 1.649 19.376 1.983.82.08 1.625-.247 2.126-.86l1.856-2.254c1.012-1.234.406-3.042-1.179-3.504-5.025-1.473-14.837-4.81-21.59-4.293-9.668.741-16.549 1.091-22.466 11.046h.008Z"
            fill="#000"
          />
          <Path
            id="Vector_2"
            d="M194.967 170.684c.095-4.962-4.412-13.786-4.532-25.294-.088-8.848 4.747-19.408 2.079-20.236-2.668-.828-5.352 9.039-5.503 20.356-.096 7.096 5.535 25.166 2.914 26.432-2.62 1.275-18.994-1.991-19.679.725-.685 2.716 2.748 3.249 13.929 4.054 8.689-.351 10.696-1.068 10.8-6.029l-.008-.008Z"
            fill="#2E2017"
            fillOpacity={0.75}
          />
          <Path
            id="Vector_3"
            d="M190.052 128.379c-.103.868.693 1.593 1.585 1.45 3.6-.582 10.075-1.585 13.969-1.474 4.603.128 11.277.868 11.277.868s.868-6.681-.733-7.78c-1.6-1.1-7.207-1.163-11.547-1.163-4.341 0-7.072.908-9.414 1.871-3.639 1.513-4.89 4.15-5.137 6.228Z"
            fill="#000"
          />
          <Path
            id="Vector_4"
            d="M172.006 138.247c-10.52-10.704-30.151-1.386-33.767 2.166-.502.494-.557 1.37-.119 1.967.263.358.637.526 1.003.502.247-.016.486-.12.685-.319 1.091-1.075 3.95-2.787 7.606-4.197 0 .255 0 .51.031.773.375 3.177 3.417 5.431 6.794 5.033 3.377-.398 5.814-3.297 5.439-6.475a5.375 5.375 0 0 0-.494-1.68c4.15.04 8.195 1.186 11.269 4.316.502.51 1.259.462 1.689-.111.43-.574.366-1.458-.136-1.967v-.008Z"
            fill="#000"
          />
          <Path
            id="Vector_5"
            d="M216.31 136.964c-3.202-2.962-18.907-9.19-24.713 3.043-.278.581-.175 1.465.231 1.975.406.501.956.438 1.235-.144a11.659 11.659 0 0 1 2.054-3.034c.454 3.409 3.735 5.814 7.375 5.392 3.679-.43 6.331-3.584 5.917-7.048a6.074 6.074 0 0 0-.239-1.099c3.393.796 6.26 2.277 7.359 3.289.175.167.366.231.55.207.27-.032.509-.263.637-.653.215-.653.024-1.521-.414-1.928h.008Z"
            fill="#000"
          />
          <Path
            id="Vector_6"
            d="M191.231 252.116s1.338 12.416-11.93 12.376c-31.68 2.803-75.992-34.827-75.992-34.827L46.183 260.86c27.333 26.488 64.58 42.799 105.65 42.799 32.589 0 62.781-10.274 87.517-27.755l-48.119-23.796v.008Z"
            fill="#000"
          />
          <Path
            id="Vector_7"
            d="M189.909 226.655a42.658 42.658 0 0 1-5.025 1.035c-20.101 2.883-41.158.263-48.015-5.614-6.857-5.878-14.128-21.75-21.686-29.881 9.27 16.732 20.818 62.151 71.341 68.227.757.088 1.386.454 2.055.566 3.209-3.656 2.652-8.864 2.652-8.864s-5.169-18.899-1.322-25.461v-.008Z"
            fill="#2E2017"
            fillOpacity={0.75}
          />
          <G id="accessories" fill={c.accessories}>
            <Path
              id="accessories_2"
              d="M157.273 41.922c25.445-3.72 34.978-1.593 42.488 3.377-3.146-5.392-9.613-14.519-18.15-16.35-12.273-2.636-25.429-4.906-25.429-4.906s-5.503-15.992-30.415-7.916c-21.518 6.976-18.675 23.908-18.675 23.908s-13.698 12.28-15.3 24.728c-1.122 8.712-2.763 20.172-3.647 26.28 9.278-15.147 39.964-44.852 69.12-49.113l.008-.008Z"
            />
            <Path
              id="accessories_3"
              d="M206.187 52.737c-2.843-2.397-5.296-4.563-8.011-6.363-7.518-4.97-17.043-7.096-42.488-3.377-29.156 4.26-59.841 33.975-69.12 49.114-1.744 2.851-2.74 5.185-2.81 6.738-1.251 25.046 7.653 32.445 7.653 32.445s24.266-52.148 74.996-61.18c27.715-4.937 50.723 15.761 50.723 15.761s-.215-24.099-10.935-33.138h-.008Z"
            />
          </G>
          <Path
            id="Vector_8"
            d="M105.507 38.904s-.056-.326-.088-.884c-.024.359-.032.693-.032.996.064-.056.12-.112.12-.112Z"
            fill="#FDFDFE"
          />
          <Path
            id="Vector_9"
            opacity={0.75}
            d="M186.652 205.694c-4.484.087-7.112-1.84-7.184-1.88-.382-.215-.526-.717-.318-1.123a.767.767 0 0 1 1.067-.334c.016 0 3.576 1.33 6.387 1.33 2.811 0 5.184-1.577 5.208-1.585a.764.764 0 0 1 1.083.263.854.854 0 0 1-.247 1.139c-.087.063-1.513 2.102-5.996 2.198v-.008Z"
            fill="#2E2017"
          />
          <Path
            id="Vector_10"
            d="M205.439 191.43s-8.84 1.704-18.699 1.163c-10.911-.597-22.944-3.401-22.944-2.15 0 2.381 16.78 9.795 22.577 9.795 7.598 0 19.393-7.804 19.058-8.816l.008.008Z"
            fill="#2E2017"
            fillOpacity={0.75}
          />
          <G id="hair" fill={c.hair}>
            <Path
              id="hair_2"
              d="M195.731 202.636s-3.465 3.52-8.896 3.344c-5.432-.183-11.843-4.005-11.843-4.005s6.157 12.551 10.736 12.2c.454-.031 6.331-.661 10.003-11.531v-.008Z"
            />
            <Path
              id="hair_3"
              d="M188.284 178.33s3.584-1.689 6.021-1.283c2.437.406 17.648 15.912 17.935 17.864.295 1.959-4.691 6.235-9.214 5.957-4.516-.279-.717-10.33-14.678-11.206-22.18-1.393-22.53 13.897-25.246 14.089-2.715.191-12.694-4.986-13.092-6.857-.399-1.88 3.376-8.275 8.529-10.967 5.153-2.692 17.529-10.003 20.165-9.899 2.636.103 9.58 2.309 9.58 2.309v-.007Z"
            />
            <Path
              id="hair_4"
              d="M217.122 85.876s-23.008-20.698-50.723-15.76c-48.206 8.584-72.512 56.106-74.813 60.804h.016c6.865-2.317 11.269 1.402 14.86 7.893.04.374.454 3.265 1.068 7.494l9.517-6.156a1264.799 1264.799 0 0 0-.335-13.802c3.464-7.088 7.231-7.98 7.502-11.166.526-6.132-2.453-23.947 10.624-31.418 5.774 15.22 15.379 12.623 15.379 12.623s-2.406-1.943-2.732-8.441c-.175-3.528 3.058-6.1 6.061-7.725 8.473.804 15.665 4.125 22.315 3.902 10.488-.35 4.69-6.411 14.391-5.838 22.88 1.362 26.87 30.359 26.87 30.359s3.743-1.816 3.783-8.362c.024-3.903-3.783-14.391-3.783-14.391v-.016Z"
            />
          </G>
        </G>
      </G>
    </Svg>
  );
};
